import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class PlayerService {

  play = new EventEmitter();
  end_of_song = new EventEmitter();
  rpm = new EventEmitter();
  needleDown = new EventEmitter();
  position = new EventEmitter();
  speed = new EventEmitter();
  new_audio = new EventEmitter();

  constructor() { }

  play_record() {
    this.play.emit(true);
  }

  stop_record() {
    this.play.emit(false);
  }

  setRPM(rpm) {
    this.rpm.emit(rpm);
  }

  setNeedleDown() {
    this.needleDown.emit(true);
  }

  setNeedleUp() {
    this.needleDown.emit(false);
  }

  setPosition(position) {
    this.position.emit(position);
  }

  setSpeed(speed1, speed2) {
    this.speed.emit([speed1, speed2]);
  }

  newAudio() {
    this.new_audio.emit(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/player.service.ts